import {BaseModel} from '../base';
import {category} from '../../services/category';

class CategoryModel extends BaseModel {
    constructor(data, index) {
        super(...arguments);
        this.order = this.order || index;
    }

    static $query(company) {
        return category.query(company);
    }
}

export {
    CategoryModel
};
